import { render, staticRenderFns } from "./selectSort.vue?vue&type=template&id=c23d7c6e&"
import script from "./selectSort.vue?vue&type=script&lang=js&"
export * from "./selectSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports